module.exports = __webpack_public_path__ + "img/header.bdc931b4.png";